import React, { type ReactNode } from 'react';

import { Interior, MainWrapper, StyledSoloSection } from './styles';

export interface MainProps {
    children: ReactNode;
}

export function Main({ children }: MainProps) {
    return <MainWrapper>{children}</MainWrapper>;
}

export interface SoloSectionProps {
    children: ReactNode;
    gutters?: boolean;
    padded?: boolean;
}

function SoloSection({ children, gutters = false, padded = false }: SoloSectionProps) {
    return (
        <StyledSoloSection $gutters={gutters} $padded={padded}>
            <Interior>{children}</Interior>
        </StyledSoloSection>
    );
}

Main.SoloSection = SoloSection;
